export default __webpack_public_path__ + "fonts/mulish-v12-latin-regular.woff2";